import { useTranslation } from 'gatsby-plugin-react-i18next'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

export interface StepType {
  step: number | string
  title: string
}

export interface BookingProgressType {
  activeStep: number
}

export const ProgressBar = ({
  activeStep,
}: BookingProgressType): JSX.Element => {
  const { t } = useTranslation()
  const progressData: StepType[] = [
    {
      step: 1,
      title: t('components.progress-bara.step-1'),
    },
    {
      step: 2,
      title: t('components.progress-bara.step-2'),
    },
    {
      step: 3,
      title: t('components.progress-bara.step-3'),
    },
    {
      step: 4,
      title: t('components.progress-bara.step-4'),
    },
  ]

  return (
    <div className="booking-progress-bar">
      <div className="step-detail">
        {progressData.map((step) => {
          return (
            <div className="step-element" key={'progress' + step.step}>
              <div
                className={'icon' + (step.step === activeStep ? ' active' : '')}
              >
                {step.step}
              </div>
              <div className="name">{step.title}</div>
            </div>
          )
        })}
      </div>
      <div className="line-step" />
    </div>
  )
}
